import React, { Component } from "react";
import "./TimerDisplay.css";
import WithContainer from "./WithContainer";
import { StatePersistor } from "../../utils/StatePersistor";

const persistedTime = {
  decidingKey: "operatorID",
  lifespanSeconds: 600,
  persistorPrefix: "-",
};

export class TimerDisplay extends Component {
  constructor(props) {
    super(props);

    const key = "currentTick-" + this.props.timer;

    let stateMatch = {};
    stateMatch[key] = 0;

    let savedTick = StatePersistor.restoreState(
      stateMatch,
      persistedTime.lifespanSeconds,
      persistedTime.decidingKey,
      persistedTime.persistorPrefix
    )[key];

    this.state = {
      currentTick: savedTick,
    };
  }

  componentDidMount() {
    this.timerID = setInterval(this.timer, 1000);

    if (this.props.type === 3) {
      this.setState({
        currentTick: 0,
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);

    if (this.props.type === 2) {
      this._savePersistedState(persistedTime.persistorPrefix, 0);
    }
  }

  _savePersistedState(prefix, value) {
    const key = `currentTick-${this.props.timer}`;
    let stateMatch = {};
    stateMatch[key] = value;
    StatePersistor.insertState(stateMatch, prefix);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.trigger !== this.props.trigger) {
      this.setState({
        currentTick: 0,
      });
    }
    this._savePersistedState(
      persistedTime.persistorPrefix,
      this.state.currentTick
    );
  }

  timer = () => {
    let currentTick = this.state.currentTick;
    currentTick += 1;

    this.setState({
      currentTick,
    });
  };

  showTick = () => {
    const minutes = Math.floor(this.state.currentTick / 60);
    const seconds = this.state.currentTick - minutes * 60;
    let minuteString = minutes.toString().padStart(2, "0");
    let secondString = seconds.toString().padStart(2, "0");
    return `${minuteString}:${secondString}`;
  };

  render() {
    if (
      this.props.trigger === -1 ||
      this.props.trigger === "" ||
      (this.props.show !== undefined && !this.props.show)
    ) {
      return null;
    }
    return <div className={this.props.className}>{this.showTick()}</div>;
  }
}

export default WithContainer(TimerDisplay);
